/**
 * Herald event kinds.
 *
 * Herald reuses the NIP-01 event envelope, so kind numbers are allocated inside
 * the Nostr kind space and follow its replaceability rules:
 *   - 1000..9999      regular (stored, all copies kept)
 *   - 10000..19999    replaceable (latest per (pubkey, kind) kept)
 *   - 30000..39999    addressable / parameterized-replaceable (latest per (pubkey, kind, d-tag))
 */
export const KIND = {
  /** NIP-01 profile metadata. Sender display name, domain, logo. */
  SENDER_PROFILE: 0,

  /** Public broadcast (newsletter). Fanout-on-read: published once, pulled by many. */
  BROADCAST: 1200,
  /** Directed message (transactional). NIP-44 encrypted to a single recipient. */
  DIRECTED: 1201,

  /** Subscriber -> sender: signed request to join a channel. Carries accepted terms. */
  SUBSCRIBE: 9000,
  /** Subscriber -> sender: signed revocation of a subscription. */
  UNSUBSCRIBE: 9001,
  /** Sender -> subscriber: countersigned consent receipt referencing a SUBSCRIBE. */
  CONSENT_RECEIPT: 9002,
  /** Subscriber -> world: signed abuse report embedding the offending event as evidence. */
  ABUSE_REPORT: 9100,
  /** Subscriber -> sender: delivery/read receipt for a DIRECTED message. */
  DELIVERY_RECEIPT: 9200,

  /** Sender manifest: delegated signing keys, relays, revocations. Signed by the ROOT key. */
  MANIFEST: 31001,
  /** Channel definition: type, frequency cap, retention, privacy mode. `d` tag = channel slug. */
  CHANNEL: 31000,
  /** Registry admission signed by a relay operator. `d` tag = sender root. Optional gate. */
  REGISTRY_ENTRY: 31100,
};

/** Kinds a relay must never serve to an unauthenticated reader. */
export const PRIVATE_KINDS = new Set([KIND.DIRECTED, KIND.SUBSCRIBE, KIND.UNSUBSCRIBE, KIND.CONSENT_RECEIPT, KIND.DELIVERY_RECEIPT]);

export function isReplaceable(kind) { return kind >= 10000 && kind < 20000; }
export function isAddressable(kind) { return kind >= 30000 && kind < 40000; }
export function isEphemeral(kind) { return kind >= 20000 && kind < 30000; }
